import { ComponentPropsWithoutRef, FC } from 'react';
import { Icon, Alert } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Shield, Heart, RoundCheck, Check } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

const MessageIcons = {
    shield: <Shield />,
    heart: <Heart />,
    checkRound: <RoundCheck />,
    check: <Check />,
};

export type MessageIconsType = keyof typeof MessageIcons;

type Props = ComponentPropsWithoutRef<'div'> & {
    text: string;
    icon?: MessageIconsType;
};

export const GreenMessage: FC<Props> = (props) => {
    const { text, icon, className } = props;
    const isMobile = useIsMobile();
    return (
        <Alert
            icon={
                icon &&
                !isMobile && (
                    <Icon color="green" background="white" size={16}>
                        {MessageIcons[icon]}
                    </Icon>
                )
            }
            color="green"
            variant="primary"
            subtitle={<Text size={14}>{text}</Text>}
            className={className}
        />
    );
};
